export default "https://cdn-static.gokick.com/assets/6ff5832d0d355fee068eb0a1603b37a2d61221c6/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";